/**
 * Created by 新思 on 2017/3/6.
 */
export default {
	navigationTitle:"",
	navigationShow: false,
	nowClassify: 1, //分类 1、推荐 2、视频 3、招聘 4、教育
	messageNumber: 0 ,  // 未读消息数
	problem :{},
	payData:[],
  	city:"",//当前城市
  	ingot:"true"//元宝商城新开带头页面
    
}



// WEBPACK FOOTER //
// ./src/vuex/state.js